module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("js-cookie");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/config");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/helpers/classCallCheck");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/promise");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/apis/article");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/helpers/createClass");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/apis/comment");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/utils/core");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/apis/wx");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("weixin-js-sdk");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/apis/file");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/helpers/defineProperty");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/array/from");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/symbol");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/symbol/iterator");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/url");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/regenerator");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/object/assign");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/helpers/asyncToGenerator");

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/json/stringify");

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/parse-int");

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs2/core-js/object/keys");

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(27);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(2);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/helpers/defineProperty"
var defineProperty_ = __webpack_require__(11);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "smarket-pithy/lib/apis/article"
var article_ = __webpack_require__(4);
var article_default = /*#__PURE__*/__webpack_require__.n(article_);

// EXTERNAL MODULE: external "smarket-pithy/lib/apis/file"
var file_ = __webpack_require__(10);
var file_default = /*#__PURE__*/__webpack_require__.n(file_);

// EXTERNAL MODULE: external "smarket-pithy/lib/apis/comment"
var comment_ = __webpack_require__(6);
var comment_default = /*#__PURE__*/__webpack_require__.n(comment_);

// CONCATENATED MODULE: ./src/packages/article/article_model.js



/**
 * Created by eg_li on 2021/6/20
 */




var article_model_ArticleModel = /*#__PURE__*/function () {
  function ArticleModel(articleId) {
    classCallCheck_default()(this, ArticleModel);

    this.name = 'article';
    this.articleId = articleId;
    this.articleInfo = {}; //文章详情

    this.canLike = false; //是否可以点赞

    this.filesList = []; //文章关联文件列表

    this.commentList = []; //评论列表
  }

  createClass_default()(ArticleModel, [{
    key: "beforeLoad",
    value: function beforeLoad() {
      return true;
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;

      this.beforeLoad();
      return article_default.a.onArticleGet({
        articleId: this.articleId
      }).then(function (res) {
        _this.initData(res.content);

        return _this.articleInfo;
      });
    }
  }, {
    key: "beforeInit",
    value: function beforeInit(data) {
      return true;
    }
  }, {
    key: "initData",
    value: function initData(data) {
      this.beforeInit();
      this.articleInfo = data; //文章浏览记录

      this.browse(); // //是否开启点赞
      // if (this.articleInfo.isAllowedLike === 1) {
      //   this.getLikeStatus()
      // }
      // //是否开启资料下载
      // if (this.articleInfo.fileIds) {
      //   this.getFileList()
      // }
      // //是否开启评论
      // if (this.articleInfo.isAllowedComment === 1) {
      //   this.getCommentList()
      // }
    }
  }, {
    key: "browse",
    value: function browse() {
      return article_default.a.onArticleBrowse({
        articleId: this.articleId,
        pageTitle: this.articleInfo.title,
        browseInfo: {}
      });
    }
  }, {
    key: "getLikeStatus",
    value: function getLikeStatus() {
      var _this2 = this;

      return article_default.a.getLikeStatus({
        articleId: this.articleId
      }).then(function (res) {
        _this2.canLike = !!res.content.canLike;
        return _this2.canLike;
      });
    }
  }, {
    key: "setLikeStatus",
    value: function setLikeStatus() {
      var _this3 = this;

      return article_default.a.onArticleLike({
        articleId: this.articleId
      }).then(function (res) {
        if (res.content) {
          _this3.hasLike = true;
        }

        return _this3.hasLike;
      });
    }
  }, {
    key: "getFileList",
    value: function getFileList() {
      var _this4 = this;

      var fileIds = this.articleInfo.fileIds.split('|');
      return file_default.a.getListForWeChat({
        fileIds: fileIds
      }).then(function (res) {
        _this4.filesList = res.content || [];
        return _this4.filesList;
      });
    }
  }, {
    key: "downloadWithEmail",
    value: function downloadWithEmail(_ref) {
      var fileList = _ref.fileList,
          email = _ref.email;
      return file_default.a.downloadWithEmail({
        fileList: fileList,
        articleId: this.articleId,
        email: email
      });
    }
  }, {
    key: "preview",
    value: function preview() {}
  }, {
    key: "getCommentList",
    value: function getCommentList() {
      var _this5 = this;

      return comment_default.a.onCommentQuery({
        subVersionId: this.articleId,
        topicId: this.articleInfo.topicId
      }).then(function (res) {
        var commentList = res.content.items || [];
        var topicData = res.content.topicData;
        _this5.commentList = commentList;
        _this5.topicData = topicData;
        return {
          commentList: commentList,
          topicData: topicData
        };
      });
    }
  }, {
    key: "createComment",
    value: function createComment(_ref2) {
      var content = _ref2.content,
          createrPic = _ref2.createrPic,
          createrLocation = _ref2.createrLocation,
          nickname = _ref2.nickname;
      return comment_default.a.onCommentCreate({
        content: content,
        createrLocation: createrLocation,
        createrPic: createrPic,
        nickname: nickname,
        isAnonymous: 1,
        commentId: 0,
        subVersionId: this.articleId,
        topicId: this.articleInfo.topicId,
        moduleId: this.articleInfo.moduleId,
        title: this.articleInfo.title,
        weChatId: this.articleInfo.authorisedWeChatId,
        instanceId: this.articleInfo.instanceId,
        nodeId: this.articleInfo.nodeId
      }).then(function (res) {
        return res.content;
      });
    }
  }, {
    key: "deleteComment",
    value: function deleteComment(commentId) {
      return comment_default.a.onCommentDelete({
        commentId: commentId,
        topicId: this.articleInfo.topicId
      }).then(function (res) {
        return res.content;
      });
    }
  }, {
    key: "likeComment",
    value: function likeComment(commentId) {
      return comment_default.a.onCommentLike({
        commentIds: [commentId]
      }).then(function (res) {
        return res.content;
      });
    }
  }]);

  return ArticleModel;
}();

/* harmony default export */ var article_model = (article_model_ArticleModel);
// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/array/from"
var from_ = __webpack_require__(12);
var from_default = /*#__PURE__*/__webpack_require__.n(from_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/symbol"
var symbol_ = __webpack_require__(13);
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/symbol/iterator"
var iterator_ = __webpack_require__(14);
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator_);

// CONCATENATED MODULE: ./src/packages/article/articleList_model.js






function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof symbol_default.a !== "undefined" && o[iterator_default.a] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from_default()(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Created by eg_li on 2021/6/20
 */


var articleList_model_ArticleListModel = /*#__PURE__*/function () {
  function ArticleListModel(articleCategoryId) {
    classCallCheck_default()(this, ArticleListModel);

    this.name = 'articleList';
    this.articleCategoryId = articleCategoryId;
    this.articleList = [];
    this.total = 0;
  }

  createClass_default()(ArticleListModel, [{
    key: "beforeLoad",
    value: function beforeLoad() {
      return true;
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;

      this.beforeLoad();
      return article_default.a.onArticleQuery({
        articleCategoryId: this.articleCategoryId
      }).then(function (res) {
        _this.initData(res.content);

        return _this.articleList;
      });
    }
  }, {
    key: "beforeInit",
    value: function beforeInit(data) {
      return true;
    }
  }, {
    key: "initData",
    value: function initData(data) {
      this.beforeInit(data);

      if (data && data.total > 0) {
        var items = data.items || [];
        this.total = data.total;

        var _iterator = _createForOfIteratorHelper(items),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            this.articleList.push(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return ArticleListModel;
}();

/* harmony default export */ var articleList_model = (articleList_model_ArticleListModel);
// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/promise"
var promise_ = __webpack_require__(3);
var promise_default = /*#__PURE__*/__webpack_require__.n(promise_);

// CONCATENATED MODULE: ./src/packages/article/articleCategory_model.js




/**
 * Created by eg_li on 2021/6/20
 */


var articleCategory_model_ArticleCategoryModel = /*#__PURE__*/function () {
  function ArticleCategoryModel(articleCategoryId) {
    classCallCheck_default()(this, ArticleCategoryModel);

    this.name = 'articleCategory';
    this.articleCategoryId = articleCategoryId;
    this.articleCategoryInfo = {};
  }

  createClass_default()(ArticleCategoryModel, [{
    key: "beforeLoad",
    value: function beforeLoad() {
      return true;
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;

      this.beforeLoad();
      return article_default.a.onArticleCategoryGet({
        articleCategoryId: this.articleCategoryId
      }).then(function (res) {
        _this.initData(res.content);

        return promise_default.a.resolve(_this.articleCategoryInfo);
      }).catch(function (error) {
        return promise_default.a.reject(error);
      });
    }
  }, {
    key: "beforeInit",
    value: function beforeInit(data) {
      return true;
    }
  }, {
    key: "initData",
    value: function initData(data) {
      this.beforeInit(data);
      this.articleCategoryInfo = data;
    }
  }]);

  return ArticleCategoryModel;
}();

/* harmony default export */ var articleCategory_model = (articleCategory_model_ArticleCategoryModel);
// CONCATENATED MODULE: ./src/packages/article/articleCategoryList_model.js



function articleCategoryList_model_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof symbol_default.a !== "undefined" && o[iterator_default.a] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = articleCategoryList_model_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function articleCategoryList_model_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return articleCategoryList_model_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from_default()(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return articleCategoryList_model_arrayLikeToArray(o, minLen); }

function articleCategoryList_model_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






/**
 * Created by eg_li on 2021/6/20
 */


var articleCategoryList_model_ArticleCategoryListModel = /*#__PURE__*/function () {
  function ArticleCategoryListModel(articleCategoryId) {
    classCallCheck_default()(this, ArticleCategoryListModel);

    this.name = 'articleCategoryList';
    this.articleCategoryId = articleCategoryId;
    this.articleCategoryList = [];
    this.total = 0;
  }

  createClass_default()(ArticleCategoryListModel, [{
    key: "beforeLoad",
    value: function beforeLoad() {
      return true;
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;

      this.beforeLoad();
      return article_default.a.onArticleCategoryQuery({
        articleCategoryId: this.articleCategoryId
      }).then(function (res) {
        _this.initData(res.content);

        return promise_default.a.resolve(_this.articleCategoryList);
      }).catch(function (error) {
        return promise_default.a.reject(error);
      });
    }
  }, {
    key: "beforeInit",
    value: function beforeInit() {
      return true;
    }
  }, {
    key: "initData",
    value: function initData(data) {
      this.beforeInit();

      if (data && data.total > 0) {
        var items = data.items || [];
        this.total = data.total;

        var _iterator = articleCategoryList_model_createForOfIteratorHelper(items),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            this.articleCategoryList.push(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return ArticleCategoryListModel;
}();

/* harmony default export */ var articleCategoryList_model = (articleCategoryList_model_ArticleCategoryListModel);
// CONCATENATED MODULE: ./src/packages/article/index.js




/* harmony default export */ var article = ({
  article: article_model,
  articleList: articleList_model,
  articleCategory: articleCategory_model,
  articleCategoryList: articleCategoryList_model
});
// CONCATENATED MODULE: ./src/packages/custom-form/customForm.js


var customForm_CustomForm = function CustomForm(props) {
  classCallCheck_default()(this, CustomForm);

  this.name = 'customForm';
};

/* harmony default export */ var customForm = (customForm_CustomForm);
// CONCATENATED MODULE: ./src/packages/custom-form/index.js

/* harmony default export */ var custom_form = (customForm);
// CONCATENATED MODULE: ./src/packages/file/file.js


var file_File = function File(props) {
  classCallCheck_default()(this, File);

  this.name = 'File';
};

/* harmony default export */ var file = (file_File);
// CONCATENATED MODULE: ./src/packages/file/index.js

/* harmony default export */ var packages_file = (file);
// CONCATENATED MODULE: ./src/packages/questionnaire/questionnaire.js


var questionnaire_Questionnaire = function Questionnaire(props) {
  classCallCheck_default()(this, Questionnaire);

  this.name = 'Question';
};

/* harmony default export */ var questionnaire = (questionnaire_Questionnaire);
// CONCATENATED MODULE: ./src/packages/questionnaire/index.js

/* harmony default export */ var packages_questionnaire = (questionnaire);
// EXTERNAL MODULE: external "js-cookie"
var external_js_cookie_ = __webpack_require__(0);
var external_js_cookie_default = /*#__PURE__*/__webpack_require__.n(external_js_cookie_);

// EXTERNAL MODULE: external "smarket-pithy/lib/config"
var config_ = __webpack_require__(1);
var config_default = /*#__PURE__*/__webpack_require__.n(config_);

// CONCATENATED MODULE: ./src/tools/cookies.js


external_js_cookie_default.a.defaults.domain = config_default()('cookies.domain') || "";

var cookies_getGlobalUserId = function getGlobalUserId() {
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  uuid = uuid.replace(/-/g, '');
  external_js_cookie_default.a.globalUserId(uuid, {
    expires: 365
  });
  return uuid;
}; //smarketMember 该cookie表示登陆信息


external_js_cookie_default.a.smarketMember = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var schemaId = args[0],
      smarketMember = args[1],
      _args$ = args[2],
      options = _args$ === void 0 ? {} : _args$;
  var flag = "".concat(config_default()('cookie.flag.member') || 'smarketMember', "_").concat(schemaId);

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, smarketMember, options);
    return;
  }

  return external_js_cookie_default.a.getJSON(flag);
};

external_js_cookie_default.a.smarketMember.remove = function (schemaId) {
  var flag = "".concat(config_default()('cookie.flag.member') || 'smarketMember', "_").concat(schemaId);
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
}; //操作openId的cookie,该cookie表示用户的微信openId信息


external_js_cookie_default.a.openId = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var weChatId = args[0],
      openId = args[1],
      options = args[2];
  var flag = (config_default()('cookie.flag.openId') || 'openId') + weChatId;

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, openId, options);
    return;
  }

  return external_js_cookie_default.a.get(flag);
};

external_js_cookie_default.a.openId.remove = function (weChatId) {
  var flag = (config_default()('cookie.flag.openId') || 'openId') + weChatId;
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
};

external_js_cookie_default.a.globalUserId = function () {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var globalUserId = args[0],
      options = args[1];
  var flag = "".concat(config_default()('cookie.flag.globalUserId') || 'globalUserId');

  if (args.length > 0) {
    external_js_cookie_default.a.set(flag, globalUserId, options);
    return;
  }

  return external_js_cookie_default.a.get(flag) || cookies_getGlobalUserId();
};

external_js_cookie_default.a.globalUserId.remove = function () {
  var flag = "".concat(config_default()('cookie.flag.globalUserId') || 'globalUserId');
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
}; //操作手机号的cookie,该cookie表示用户手机验证状态


external_js_cookie_default.a.mobile = function () {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  var schemaId = args[0],
      mobile = args[1],
      options = args[2];
  var flag = "".concat(config_default()('cookie.flag.mobile') || 'mobile', "_").concat(schemaId);

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, mobile, options);
    return;
  }

  return external_js_cookie_default.a.get(flag);
}; //删除手机号


external_js_cookie_default.a.mobile.remove = function (schemaId) {
  var flag = "".concat(config_default()('cookie.flag.mobile') || 'mobile', "_").concat(schemaId);
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
};

external_js_cookie_default.a.token = function () {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var schemaId = args[0],
      token = args[1],
      options = args[2];
  var flag = "".concat(config_default()('cookie.flag.token') || 'token', "_").concat(schemaId);

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, token, options);
    return;
  }

  return external_js_cookie_default.a.get(flag);
};

external_js_cookie_default.a.token.remove = function (schemaId) {
  var flag = "".concat(config_default()('cookie.flag.token') || 'token', "_").concat(schemaId);
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
};

external_js_cookie_default.a.tokenInfo = function () {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var schemaId = args[0],
      tokenInfo = args[1],
      options = args[2];
  var flag = "".concat(config_default()('cookie.flag.tokenInfo') || 'tokenInfo', "_").concat(schemaId);

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, tokenInfo, options);
    return;
  }

  return external_js_cookie_default.a.get(flag);
};

external_js_cookie_default.a.tokenInfo.remove = function (schemaId) {
  var flag = "".concat(config_default()('cookie.flag.tokenInfo') || 'tokenInfo', "_").concat(schemaId);
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
};

external_js_cookie_default.a.verify = function () {
  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var weChatId = args[0],
      verify = args[1],
      options = args[2];
  var flag = "".concat(config_default()('cookie.flag.verify') || 'verify', "_").concat(weChatId);

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, verify, options);
    return;
  }

  return external_js_cookie_default.a.get(flag);
};

external_js_cookie_default.a.verify.remove = function (weChatId) {
  var flag = "".concat(config_default()('cookie.flag.verify') || 'verify', "_").concat(weChatId);
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
};

external_js_cookie_default.a.verifyInfo = function () {
  for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  var weChatId = args[0],
      verifyInfo = args[1],
      options = args[2];
  var flag = "".concat(config_default()('cookie.flag.verifyInfo') || 'verifyInfo', "_").concat(weChatId);

  if (args.length > 1) {
    external_js_cookie_default.a.set(flag, verifyInfo, options);
    return;
  }

  return external_js_cookie_default.a.getJSON(flag);
};

external_js_cookie_default.a.verifyInfo.remove = function (weChatId) {
  var flag = "".concat(config_default()('cookie.flag.verifyInfo') || 'verifyInfo', "_").concat(weChatId);
  external_js_cookie_default.a.remove(flag, {
    path: '/'
  });
};

/* harmony default export */ var cookies = (external_js_cookie_default.a);
// EXTERNAL MODULE: external "smarket-pithy/lib/utils/core"
var core_ = __webpack_require__(7);
var core_default = /*#__PURE__*/__webpack_require__.n(core_);

// CONCATENATED MODULE: ./src/tools/config.js

var configDict = {};

var Config = function Config(key, val) {
  var argsLen = arguments.length;

  if (argsLen > 1) {
    setValueByExpression(key, val);
  } else {
    return argsLen == 0 ? configDict : getValueByExpression(key);
  }
}; // 设置指定值为undefined


Config.remove = function (key) {
  configDict[key] = undefined;
};

Config.extend = function () {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  core_["extend"].call(null, configDict, target);
};

function getValueByExpression(expression) {
  try {
    return Function('__withObj__', "with(__withObj__) { return ".concat(expression, "; }"))(configDict);
  } catch (e) {}
}

function setValueByExpression(expression, val) {
  try {
    Function('__withObj__', '__setVal__', "with(__withObj__) { ".concat(expression, " = __setVal__; }"))(configDict, val);
  } catch (e) {}
}

Config.extend(window.$config || window.config);
/* harmony default export */ var tools_config = (Config);
// EXTERNAL MODULE: external "@babel/runtime-corejs2/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(21);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/regenerator"
var regenerator_ = __webpack_require__(16);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/json/stringify"
var stringify_ = __webpack_require__(22);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify_);

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__(23);
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// CONCATENATED MODULE: ./src/tools/request.js






var service = external_axios_default.a.create({
  baseURL: config_default()('api.gateway.general') || '',
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

service.postJson = function (url, params, config) {
  return new promise_default.a(function (resolve, reject) {
    service.post(url, params, config).then(function (response) {
      resolve(response);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
};

service.getJson = function (url, config) {
  return new promise_default.a( /*#__PURE__*/function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(resolve, reject) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              service.get(url, config).then(function (response) {
                resolve(response);
              }, function (err) {
                reject(err);
              }).catch(function (error) {
                reject(error);
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}; // request interceptor


service.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = config.data || {};
    config.data = stringify_default()(config.data);
  } else {
    config.params = config.params || {};
  }

  return config;
}, function (error) {
  console.error(error);
  return promise_default.a.reject(error);
}); // response interceptor

service.interceptors.response.use(function (response) {
  var res = response.data;

  if (res.body.result !== 0) {
    return promise_default.a.reject(res.body);
  }

  return promise_default.a.resolve(res.body);
}, function (error) {
  if (error && error.response && error.response.status == 401) {
    return;
  }

  return promise_default.a.reject(error);
});
/* harmony default export */ var request = (service);
// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/parse-int"
var parse_int_ = __webpack_require__(24);
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int_);

// CONCATENATED MODULE: ./src/tools/url.js

var strRegex = '^((https|http|ftp|rtsp|mms)://)?[a-z0-9A-Z]{3}\.([a-z0-9A-Z][a-z0-9A-Z]{0,61}?[a-z0-9A-Z]\.)+com|net|cn|cc (:s[0-9]{1-4})?/$';
var urlRegex = new RegExp(strRegex); //获取当前url查询字符串参数

var urlHash = parseUrl('hash') || {};
var urlParams = parseUrl('?') || {}; //正则

function _t() {
  return new RegExp(/(.*?)\.?([^\.]*?)\.?(com|net|org|biz|ws|in|me|co\.uk|co|org\.uk|ltd\.uk|plc\.uk|me\.uk|edu|mil|br\.com|cn\.com|eu\.com|hu\.com|no\.com|qc\.com|sa\.com|se\.com|se\.net|us\.com|uy\.com|ac|co\.ac|gv\.ac|or\.ac|ac\.ac|af|am|as|at|ac\.at|co\.at|gv\.at|or\.at|asn\.au|com\.au|edu\.au|org\.au|net\.au|id\.au|be|ac\.be|adm\.br|adv\.br|am\.br|arq\.br|art\.br|bio\.br|cng\.br|cnt\.br|com\.br|ecn\.br|eng\.br|esp\.br|etc\.br|eti\.br|fm\.br|fot\.br|fst\.br|g12\.br|gov\.br|ind\.br|inf\.br|jor\.br|lel\.br|med\.br|mil\.br|net\.br|nom\.br|ntr\.br|odo\.br|org\.br|ppg\.br|pro\.br|psc\.br|psi\.br|rec\.br|slg\.br|tmp\.br|tur\.br|tv\.br|vet\.br|zlg\.br|br|ab\.ca|bc\.ca|mb\.ca|nb\.ca|nf\.ca|ns\.ca|nt\.ca|on\.ca|pe\.ca|qc\.ca|sk\.ca|yk\.ca|ca|cc|ac\.cn|com\.cn|edu\.cn|gov\.cn|org\.cn|bj\.cn|sh\.cn|tj\.cn|cq\.cn|he\.cn|nm\.cn|ln\.cn|jl\.cn|hl\.cn|js\.cn|zj\.cn|ah\.cn|gd\.cn|gx\.cn|hi\.cn|sc\.cn|gz\.cn|yn\.cn|xz\.cn|sn\.cn|gs\.cn|qh\.cn|nx\.cn|xj\.cn|tw\.cn|hk\.cn|mo\.cn|cn|cx|cz|de|dk|fo|com\.ec|tm\.fr|com\.fr|asso\.fr|presse\.fr|fr|gf|gs|co\.il|net\.il|ac\.il|k12\.il|gov\.il|muni\.il|ac\.in|co\.in|org\.in|ernet\.in|gov\.in|net\.in|res\.in|is|it|ac\.jp|co\.jp|go\.jp|or\.jp|ne\.jp|ac\.kr|co\.kr|go\.kr|ne\.kr|nm\.kr|or\.kr|li|lt|lu|asso\.mc|tm\.mc|com\.mm|org\.mm|net\.mm|edu\.mm|gov\.mm|ms|nl|no|nu|pl|ro|org\.ro|store\.ro|tm\.ro|firm\.ro|www\.ro|arts\.ro|rec\.ro|info\.ro|nom\.ro|nt\.ro|se|si|com\.sg|org\.sg|net\.sg|gov\.sg|sk|st|tf|ac\.th|co\.th|go\.th|mi\.th|net\.th|or\.th|tm|to|com\.tr|edu\.tr|gov\.tr|k12\.tr|net\.tr|org\.tr|com\.tw|org\.tw|net\.tw|ac\.uk|uk\.com|uk\.net|gb\.com|gb\.net|vg|sh|kz|ch|info|ua|gov|name|pro|ie|hk|com\.hk|org\.hk|net\.hk|edu\.hk|us|tk|cd|by|ad|lv|eu\.lv|bz|es|jp|cl|ag|mobi|eu|co\.nz|org\.nz|net\.nz|maori\.nz|iwi\.nz|io|la|md|sc|sg|vc|tw|travel|my|se|tv|pt|com\.pt|edu\.pt|asia|fi|com\.ve|net\.ve|fi|org\.ve|web\.ve|info\.ve|co\.ve|tel|im|gr|ru|net\.ru|org\.ru|hr|com\.hr|ly|xyz)$/);
} //解码


function _d(s) {
  return decodeURIComponent(s.replace(/\+/g, ' '));
}

function _i(arg, str) {
  var sptr = arg.charAt(0),
      split = str.split(sptr);

  if (sptr === arg) {
    return split;
  }

  arg = parse_int_default()(arg.substring(1), 10);
  return split[arg < 0 ? split.length + arg : arg - 1];
}

function _f(arg, str) {
  var sptr = arg.charAt(0),
      split = str.split('&'),
      field = [],
      params = {},
      tmp = [],
      arg2 = arg.substring(1);

  for (var i = 0, ii = split.length; i < ii; i++) {
    field = split[i].match(/(.*?)=(.*)/);

    if (!field) {
      field = [split[i], split[i], ''];
    }

    if (field[1].replace(/\s/g, '') !== '') {
      field[2] = _d(field[2] || ''); // If we have a match just return it right away.

      if (arg2 === field[1]) {
        return field[2];
      } // Check for array pattern.


      tmp = field[1].match(/(.*)\[([0-9]+)\]/);

      if (tmp) {
        params[tmp[1]] = params[tmp[1]] || [];
        params[tmp[1]][tmp[2]] = field[2];
      } else {
        params[field[1]] = field[2];
      }
    }
  }

  if (sptr === arg) {
    return params;
  }

  return params[arg2];
} //解析url信息


function parseUrl(arg, url) {
  var _l = {},
      tmp,
      tmp2;

  if (arg === 'tld?') {
    return _t();
  }

  url = url || window.location.toString();

  if (!arg) {
    return url;
  }

  arg = arg.toString();

  if (tmp = url.match(/^mailto:([^\/].+)/)) {
    _l.protocol = 'mailto';
    _l.email = tmp[1];
  } else {
    // Ignore Hashbangs.
    if (tmp = url.match(/(.*?)\/#\!(.*)/)) {
      url = tmp[1] + tmp[2];
    } // Hash.


    if (tmp = url.match(/(.*?)#(.*)/)) {
      _l.hash = tmp[2];
      url = tmp[1];
    } // Return hash parts.


    if (_l.hash && arg.match(/^#/)) {
      return _f(arg, _l.hash);
    } // Query


    if (tmp = url.match(/(.*?)\?(.*)/)) {
      _l.query = tmp[2];
      url = tmp[1];
    } // Return query parts.


    if (_l.query && arg.match(/^\?/)) {
      return _f(arg, _l.query);
    } // Protocol.


    if (tmp = url.match(/(.*?)\:?\/\/(.*)/)) {
      _l.protocol = tmp[1].toLowerCase();
      url = tmp[2];
    } // Path.


    if (tmp = url.match(/(.*?)(\/.*)/)) {
      _l.path = tmp[2];
      url = tmp[1];
    } // Clean up path.


    _l.path = (_l.path || '').replace(/^([^\/])/, '/$1').replace(/\/$/, ''); // Return path parts.

    if (arg.match(/^[\-0-9]+$/)) {
      arg = arg.replace(/^([^\/])/, '/$1');
    }

    if (arg.match(/^\//)) {
      return _i(arg, _l.path.substring(1));
    } // File.


    tmp = _i('/-1', _l.path.substring(1));

    if (tmp && (tmp = tmp.match(/(.*?)\.(.*)/))) {
      _l.file = tmp[0];
      _l.filename = tmp[1];
      _l.fileext = tmp[2];
    } // Port.


    if (tmp = url.match(/(.*)\:([0-9]+)$/)) {
      _l.port = tmp[2];
      url = tmp[1];
    } // Auth.


    if (tmp = url.match(/(.*?)@(.*)/)) {
      _l.auth = tmp[1];
      url = tmp[2];
    } // User and pass.


    if (_l.auth) {
      tmp = _l.auth.match(/(.*)\:(.*)/);
      _l.user = tmp ? tmp[1] : _l.auth;
      _l.pass = tmp ? tmp[2] : undefined;
    } // Hostname.


    _l.hostname = url.toLowerCase(); // Return hostname parts.

    if (arg.charAt(0) === '.') {
      return _i(arg, _l.hostname);
    } // Domain, tld and sub domain.


    if (_t()) {
      tmp = _l.hostname.match(_t());

      if (tmp) {
        _l.tld = tmp[3];
        _l.domain = tmp[2] ? tmp[2] + '.' + tmp[3] : undefined;
        _l.sub = tmp[1] || undefined;
      }
    } // Set port and protocol defaults if not set.


    _l.port = _l.port || (_l.protocol === 'https' ? '443' : '80');
    _l.protocol = _l.protocol || (_l.port === '443' ? 'https' : 'http');
  } // Return arg.


  if (arg in _l) {
    return _l[arg];
  } // Return everything.


  if (arg === '{}') {
    return _l;
  } // Default to undefined for no match.


  return undefined;
} //添加或者更新uri中的参数

function updateParam(key, value, uri) {
  // Use window URL if no query string is provided
  if (!uri) {
    uri = window.location.href;
  } // Create a dummy element to parse the URI with


  var a = document.createElement('a'),
      // match the key, optional square bracktes, an equals sign or end of string, the optional value
  reg_ex = new RegExp(key + '((?:\\[[^\\]]*\\])?)(=|$)(.*)'),
      // Setup some additional variables
  qs,
      qs_len,
      key_found = false; // Use the JS API to parse the URI

  a.href = uri; // If the URI doesn't have a query string, add it and return

  if (!a.search) {
    a.search = '?' + key + '=' + value;
    return a.href;
  } // Split the query string by ampersands


  qs = a.search.replace(/^\?/, '').split(/&(?:amp;)?/);
  qs_len = qs.length; // Loop through each query string part

  while (qs_len > 0) {
    qs_len--; // Check if the current part matches our key

    if (reg_ex.test(qs[qs_len])) {
      // Replace the current value
      qs[qs_len] = qs[qs_len].replace(reg_ex, key + '$1') + '=' + value;
      key_found = true;
    }
  } // If we haven't replaced any occurences above, add the new parameter and value


  if (!key_found) {
    qs.push(key + '=' + value);
  } // Set the new query string


  a.search = '?' + qs.join('&');
  return a.href;
} //获取地址hash值

function getUrlHash(query) {
  query = query.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
  var expr = '[\\?#&]' + query + '=([^&#]*)';
  var regex = new RegExp(expr);
  var results = regex.exec(window.location.href);

  if (results !== null) {
    return results[1];
  } else {
    return false;
  }
} //url中删除指定参数

function removeParam(sourceURL) {
  var rtn = decodeURIComponent(sourceURL).split('?')[0],
      param,
      params_arr = [],
      queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';

  if (queryString !== '') {
    params_arr = queryString.split('&');

    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];

      for (var x = arguments.length - 1; x >= 1; x -= 1) {
        if (param === arguments[x]) {
          params_arr.splice(i, 1);
        }
      }
    }

    rtn = rtn + '?' + params_arr.join('&');
  }

  return rtn;
}
function isUrl(url) {
  return urlRegex.test(url);
}
/* harmony default export */ var tools_url = ({
  urlRegex: urlRegex,
  urlHash: urlHash,
  urlParams: urlParams,
  updateParam: updateParam,
  getUrlHash: getUrlHash,
  removeParam: removeParam,
  isUrl: isUrl,
  parseUrl: parseUrl
});
// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/object/assign"
var assign_ = __webpack_require__(20);
var assign_default = /*#__PURE__*/__webpack_require__.n(assign_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/object/keys"
var keys_ = __webpack_require__(25);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/object/get-own-property-symbols"
var get_own_property_symbols_ = __webpack_require__(17);
var get_own_property_symbols_default = /*#__PURE__*/__webpack_require__.n(get_own_property_symbols_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"
var get_own_property_descriptor_ = __webpack_require__(18);
var get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptor_);

// EXTERNAL MODULE: external "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"
var get_own_property_descriptors_ = __webpack_require__(19);
var get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptors_);

// EXTERNAL MODULE: external "smarket-pithy/lib/apis/wx"
var wx_ = __webpack_require__(8);
var wx_default = /*#__PURE__*/__webpack_require__.n(wx_);

// EXTERNAL MODULE: external "smarket-pithy/lib/url"
var url_ = __webpack_require__(15);

// EXTERNAL MODULE: external "weixin-js-sdk"
var external_weixin_js_sdk_ = __webpack_require__(9);
var external_weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(external_weixin_js_sdk_);

// CONCATENATED MODULE: ./src/tools/wx.js




function ownKeys(object, enumerableOnly) { var keys = keys_default()(object); if (get_own_property_symbols_default.a) { var symbols = get_own_property_symbols_default()(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return get_own_property_descriptor_default()(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (get_own_property_descriptors_default.a) { Object.defineProperties(target, get_own_property_descriptors_default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, get_own_property_descriptor_default()(source, key)); }); } } return target; }











var wxauth = config_default()('api.wxauth');
var wx_weChatId = config_default()('weChatId') || Object(url_["getUrlHash"])('weChatId') || '';
var __AUTH_DEFAULT__ = {
  tenantId: config_default()('tenantId'),
  schemaId: config_default()('schemaId'),
  memberFormId: config_default()('memberFormId'),
  unique: '',
  token: '',
  verify: '',
  password: '',
  checkCode: '',
  loginType: '',
  url: window.location.href.split('#')[0],
  weChatId: config_default()('weChatId')
};
var __SHARE_INIT_DEFAULT__ = {
  tenantId: config_default()('tenantId'),
  weChatId: wx_weChatId,
  jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'scanQRCode', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'hideAllNonBaseMenuItem', 'checkJsApi', 'hideMenuItems', 'showMenuItems', 'getLocation', 'openLocation'],
  url: window.location.href.split('#')[0],
  onDebug: 0
};
var __SHARE_DEFAULT__ = {
  title: document.title,
  desc: document.title,
  link: window.location.href,
  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: '' // 分享图标

};

var wx_Wx = /*#__PURE__*/function () {
  function Wx() {
    classCallCheck_default()(this, Wx);

    this.shareSDK = null;
  }
  /**
   * 微信分享初始化
   * @param params
   * @returns {Promise<unknown>}
   */


  createClass_default()(Wx, [{
    key: "initJSdk",
    value: function initJSdk(params) {
      var _this2 = this;

      if (!external_weixin_js_sdk_default.a) return new Error('Please install weixin-js-sdk first');
      if (this.shareSDK) return promise_default.a.resolve(this.shareSDK);
      return new promise_default.a(function (resolve, reject) {
        var sdkParams = assign_default()(__SHARE_INIT_DEFAULT__, params);

        Object(wx_["getJsSdkConfig"])(sdkParams).then(function (res) {
          external_weixin_js_sdk_default.a.config({
            debug: false,
            appId: res.content.wxAppId,
            timestamp: res.content.timestamp,
            nonceStr: res.content.nonceStr,
            signature: res.content.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'scanQRCode', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'hideAllNonBaseMenuItem', 'checkJsApi', 'hideMenuItems', 'showMenuItems', 'getLocation', 'openLocation']
          });
          external_weixin_js_sdk_default.a.ready(function () {
            _this2.shareSDK = external_weixin_js_sdk_default.a;
            resolve(_this2.shareSDK);
          });
          external_weixin_js_sdk_default.a.error(function (res) {
            reject(res);
          });
        });
      });
    }
    /**
     * 微信分享
     * @param shareParams
     */

  }, {
    key: "share",
    value: function share() {
      var shareParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var params = assign_default()(__SHARE_DEFAULT__, shareParams);

      if (this.shareSDK) {
        this.shareSDK.updateAppMessageShareData(params);
        this.shareSDK.updateTimelineShareData(params);
      }
    }
    /**
     *  授权跳转
     * @param scope
     */

  }, {
    key: "authorization",
    value: function authorization() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'snsapi_base';
      if (!wxauth) return; //新授权方式(非静默授权scope=(snsapi_base|snsapi_userinfo) 获取excode

      var loginUrl = wxauth + '?weChatId=' + wx_weChatId + '&scope=' + scope + '&return_url=';
      loginUrl = Object(url_["updateParam"])('return_url', encodeURIComponent(window.location.href), loginUrl);
      window.location.href = loginUrl; //重定向url
    }
    /**
     * 授权
     * @param callback
     * @returns {Promise<unknown>}
     */

  }, {
    key: "initAuth",
    value: function initAuth(callback) {
      var _this = this;

      var excode = Object(url_["getUrlHash"])('excode');
      return new promise_default.a(function (resolve) {
        if (excode) {
          Object(wx_["getByCode"])({
            code: excode
          }).then(function (data) {
            var verify = data.content.token;
            var tokenInfo = JSON.parse(window.atob(data.content.token.split('.')[1]));
            if (callback && typeof callback === 'function') callback({
              verify: verify,
              tokenInfo: tokenInfo
            });
            return resolve({
              verify: verify,
              tokenInfo: tokenInfo
            });
          }).catch(function () {
            _this.authorization('snsapi_base');
          });
        } else {
          _this.authorization('snsapi_userinfo');
        }
      });
    }
    /**
     * 微信登录
     * @param authParams
     * @param callback
     * @returns {*}
     */

  }, {
    key: "wxAuthLogin",
    value: function wxAuthLogin(authParams, callback) {
      var params = _objectSpread(_objectSpread({}, __AUTH_DEFAULT__), authParams);

      return Object(wx_["memberLogin"])(params).then(function (res) {
        if (callback && typeof callback === 'function') {
          callback(res);
        }

        return res;
      });
    }
  }]);

  return Wx;
}();

/* harmony default export */ var wx = (new wx_Wx());
// CONCATENATED MODULE: ./src/index.js



/* Automatically generated by './build/bin/build-entry.js' */














var Packages = {
  Article: article,
  CustomForm: custom_form,
  File: packages_file,
  Questionnaire: packages_questionnaire,
  Cookies: cookies,
  Config: tools_config,
  Request: request,
  Url: tools_url,
  Wx: wx
};
var Apis = {
  Article: article_default.a,
  File: file_default.a,
  Wx: wx_default.a,
  Comment: comment_default.a
};

var src_Smarket = function Smarket() {
  classCallCheck_default()(this, Smarket);

  defineProperty_default()(this, "version", '1.0.0');
};

src_Smarket.prototype.apis = {};
core_default.a.extend.call(null, src_Smarket.prototype, core_default.a);
core_default.a.extend.call(null, src_Smarket.prototype, Packages);
core_default.a.extend.call(null, src_Smarket.prototype.apis, Apis);
/* harmony default export */ var src = __webpack_exports__["default"] = (new src_Smarket());

/***/ })
/******/ ])["default"];